import { Link } from "wouter";
import { ArrowLeft, FileQuestion } from "lucide-react";

export default function NotFound() {
  return <div className="not-found"><div className="not-found-icon"><FileQuestion size={28} /></div><div className="eyebrow">404 · not in this workspace</div><h2>That page drifted<br /><em>out of frame.</em></h2><p>The route you’re looking for doesn’t exist in LocalPDF yet.</p><Link href="/" className="banner-link"><ArrowLeft size={15} /> Back to workspace</Link></div>;
}
